import { render, staticRenderFns } from "./AudienceFullDetails.vue?vue&type=template&id=b470ef5e&"
import script from "./AudienceFullDetails.vue?vue&type=script&lang=js&"
export * from "./AudienceFullDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ubuntu/src/searchie/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b470ef5e')) {
      api.createRecord('b470ef5e', component.options)
    } else {
      api.reload('b470ef5e', component.options)
    }
    module.hot.accept("./AudienceFullDetails.vue?vue&type=template&id=b470ef5e&", function () {
      api.rerender('b470ef5e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/2.0/js/modules/Audience/Listing/Components/AudienceFullDetails.vue"
export default component.exports